import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {
  ModalBaseConfig,
  ModalBaseComponent,
} from '@app/core/components/modal-base/modal-base.component';
import { LineItem, LineItemGrouping } from '@app/generated/graphql';
import { Modal } from '@app/core/interfaces/modal.interface';
import { ModalBaseComponent as ModalBaseComponent_1 } from '../../../core/components/modal-base/modal-base.component';
import { NgTemplateOutlet, KeyValuePipe } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

export type ViewAction =
  | 'accept'
  | 'wont pack'
  | 'save order'
  | 'accept planning items';

type Key = number | string;

export interface ConfirmActionModalConfig extends ModalBaseConfig {
  action: ViewAction;
  selectedLineItems?: LineItem[];
  lineItemMutations?: {
    [key in Key]: { add: LineItem[]; update: LineItem[]; remove: LineItem[] };
  };
  lineItemGroupingMutations: {
    add: LineItemGrouping[];
    update: LineItemGrouping[];
    remove: LineItemGrouping[];
  };
  tradePartners: any[];
}

@Component({
  selector: 'ag-confirm-action-modal',
  templateUrl: './confirm-action-modal.component.html',
  styleUrls: ['./confirm-action-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ModalBaseComponent_1,
    NgTemplateOutlet,
    AngularSvgIconModule,
    KeyValuePipe,
  ],
})
export class ConfirmActionModalComponent implements Modal {
  @ViewChild(ModalBaseComponent, { static: true })
  modalBase: ModalBaseComponent;

  verboseSaveDetails = 'verbose_save_details';

  showDetails =
    JSON.parse(localStorage.getItem(this.verboseSaveDetails)) ?? true;

  selectedLineItems: LineItem[];
  lineItemMutations?: {
    [key in Key]: { add: LineItem[]; update: LineItem[]; remove: LineItem[] };
  };
  lineItemGroupingMutations: {
    add: LineItemGrouping[];
    update: LineItemGrouping[];
    remove: LineItemGrouping[];
  };
  action: ViewAction;
  tradePartners: any[];

  get removeLineItemCount(): number {
    return Object.keys(this.lineItemMutations).reduce(
      (arr, key) => arr.concat(this.lineItemMutations[key].remove),
      [],
    ).length;
  }

  get addLineItemCount(): number {
    return Object.keys(this.lineItemMutations).reduce(
      (arr, key) => arr.concat(this.lineItemMutations[key].add),
      [],
    ).length;
  }

  get updateLineItemCount(): number {
    return Object.keys(this.lineItemMutations).reduce(
      (arr, key) => arr.concat(this.lineItemMutations[key].update),
      [],
    ).length;
  }

  get acceptLineItems() {
    return this.selectedLineItems.filter(
      (lineItem) => (lineItem as any).stateUpdate[1] === 'accepted',
    );
  }

  get wontPackLineItems() {
    return this.selectedLineItems.filter(
      (lineItem) => (lineItem as any).stateUpdate[1] === 'wont_pack',
    );
  }

  get revertLineItems() {
    return this.selectedLineItems.filter(
      (lineItem) => (lineItem as any).stateUpdate[1] === 'revert',
    );
  }

  constructor() {}

  lineItemMutationKeys() {
    return Object.keys(this.lineItemMutations) as [];
  }

  toggleVerboseDetails() {
    this.showDetails = !this.showDetails;

    localStorage.setItem(
      this.verboseSaveDetails,
      JSON.stringify(this.showDetails),
    );
  }

  allocationCompany(lineItem): string {
    return this.tradePartners.find((item) => item.id === lineItem.newSellerId)
      ?.name;
  }

  show = () => this.modalBase.show();
  hide = () => this.modalBase.hide();
  setLoading = (isLoading: boolean) => this.modalBase.setLoading(isLoading);

  configure(config: ConfirmActionModalConfig) {
    this.selectedLineItems = config.selectedLineItems;
    this.lineItemMutations = config.lineItemMutations;
    this.lineItemGroupingMutations = config.lineItemGroupingMutations;
    this.action = config.action;
    this.modalBase.configure(config);
    this.tradePartners = config.tradePartners;
  }
}
